// extracted by mini-css-extract-plugin
export default {"NavContainer":"NavBarAdmin_NavContainer__6Ch8q","NavLink":"NavBarAdmin_NavLink__ECSyj"};